import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Toaster } from "@/components/ui/sonner";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
          <Toaster
            richColors
            position="top-center"
            duration={4000}
            expand
            visibleToasts={5}
            closeButton
            toastOptions={{
              /* Business rule (Feb 28, 2026): every CRM alert must appear
                 at the TOP of the screen as a pop-up line and stay for at
                 least 3 seconds. We use 4000ms (4s) so the user has a
                 comfortable buffer above the 3-second minimum to actually
                 read multi-count summaries. Font/padding boosted so
                 back-office can read the message from across the desk. */
              style: {
                fontSize: "21px",
                lineHeight: "1.4",
                padding: "18px 20px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
